
    import { h } from 'vue';
    import { normalizeSlotChildren } from '@/Utils/SlotUtility';

    export default {
        render() {
            const { class: attrsClass, ...attrs } = this.$attrs;

            return h('div', { ...attrs, class: ['gfu-divider-labeled', attrsClass] }, normalizeSlotChildren(this.$slots.default));
        },
    };
